import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var compressImage = normalize.compressImage(function (args) {
  args && typeof args.quality === 'number' && (args.quality *= 33);
  return swan.compressImage(args);
}, CONTAINER_NAME.BAIDU);
export default compressImage;